import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

import { ResourceItemModel } from 'src/app/models/resource';
import { IconTypes } from '../../standalones/components/pencil-icon/pencil-icon.component';
import { UploadFile } from '../../services/document-upload.service';
import { Libraries } from './upload/upload.component';

@UntilDestroy()
@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      libraries: Libraries[];
      type: ResourceItemModel[];
      newPdfFlow?: boolean;
      allowedImageTypes?: string;
      maxFileSizeInMB?: number;
      forceLegacyUpload?: boolean;
    },
  ) {}

  closeSubmit(file?: UploadFile) {
    this.dialogRef.close(file);
  }

  protected readonly IconTypes = IconTypes;
}
